export const DESIGN_ITEM_MAPPINGS_UPDATE_SUCCESS = 'DESIGN_ITEM_MAPPINGS_UPDATE_SUCCESS';
export const DESGIN_ITEM_RESET_STATE = 'DESGIN_ITEM_RESET_STATE';

export function designItemMappingsUpdate(data) {
  return {
    type: DESIGN_ITEM_MAPPINGS_UPDATE_SUCCESS,
    data,
  };
}

export function designItemMappingsResetState() {
  return {
    type: DESGIN_ITEM_RESET_STATE,
  };
}
